import React from "react";

import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from "../ui/dialog";
import { definirBotoesOcultos } from "../../ligacoes/botoesFlutuantes";

// Pergunta aberta ao segurar um botão flutuante de ligação.
const OcultarBotoesLigacao = ({ aberto, aoFechar }) => (
	<Dialog open={aberto} onOpenChange={(v) => !v && aoFechar()}>
		<DialogContent className="sm:max-w-sm">
			<DialogHeader>
				<DialogTitle>Ocultar botões de ligação?</DialogTitle>
			</DialogHeader>
			<p className="text-sm text-muted-foreground">
				Os botões flutuantes de telefone somem da tela. Ligações recebidas
				continuam aparecendo. Para abrir o telefone ou mostrar os botões de
				novo, use o menu do usuário (ícone no canto superior).
			</p>
			<DialogFooter className="gap-2">
				<Button variant="outline" onClick={aoFechar}>
					Cancelar
				</Button>
				<Button
					onClick={() => {
						definirBotoesOcultos(true);
						aoFechar();
					}}
				>
					Ocultar
				</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
);

export default OcultarBotoesLigacao;
